import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function IcrSuccessScreen({ icr, onContinue }) {
  const { t } = useTranslation('customerFile');
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(icr);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div
      className="flex flex-col items-center py-8 px-4"
      data-testid="icr-success-screen"
    >
      <div className="relative mb-6">
        <div className="w-20 h-20 rounded-full bg-orange-50 flex items-center justify-center">
          <div className="w-12 h-12 rounded-full border-2 border-orange-500 flex items-center justify-center">
            <svg
              className="w-6 h-6 text-orange-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.5}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
        </div>
      </div>

      <h2 className="text-xl font-bold text-gray-900 mb-2">
        {t('icrSuccess.title')}
      </h2>
      <p className="text-sm text-gray-400 mb-8">{t('icrSuccess.subtitle')}</p>

      <div className="w-full max-w-md rounded-xl border border-gray-100 border-b-orange-500 border-b-2 bg-white shadow-sm flex items-stretch overflow-hidden">
        <div className="flex-1 px-6 py-5">
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2">
            {t('icrSuccess.label')}
          </p>
          <p className="text-2xl font-bold text-gray-900 tracking-wide">
            {icr}
          </p>
        </div>
        <div className="border-l border-dashed border-gray-200" />
        <button
          type="button"
          onClick={handleCopy}
          className="flex flex-col items-center justify-center px-6 gap-1 border-0 bg-transparent hover:bg-orange-50 transition-colors outline-none focus:outline-none cursor-pointer"
        >
          {copied ? (
            <svg
              className="w-5 h-5 text-green-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          ) : (
            <svg
              className="w-5 h-5 text-orange-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
              />
            </svg>
          )}
          <span
            className={`text-xs font-semibold uppercase ${copied ? 'text-green-500' : 'text-orange-500'}`}
          >
            {copied ? t('icrSuccess.copied') : t('icrSuccess.copy')}
          </span>
        </button>
      </div>

      <button
        type="button"
        onClick={onContinue}
        className="mt-8 w-full max-w-md py-3.5 bg-orange-500 text-white font-semibold rounded-xl border-0 hover:bg-orange-600 transition-colors text-base outline-none focus:outline-none cursor-pointer"
        data-testid="icr-success-screen-continue-button"
      >
        {t('icrSuccess.continue')}
      </button>
    </div>
  );
}
